// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,\nbody {\n  height: 100%;\n}\nbody {\n  margin: 0;\n  /* background:#000; */\n}\ncanvas {\n  display: block;\n}\n.waves {\n  width: 10rem;\n  position: absolute;\n  left: 50%;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  z-index: 0;\n}", ""]);
// Exports
module.exports = exports;
